import StatusOnline from '@pages/offer-page/online-status/StatusOnline.vue';
import { createApp } from 'vue';

export const onlineStatus = () => {
  if (!document.getElementById('primary-contact-status-app')) {
    return;
  }

  createApp(StatusOnline)
    .mount('#primary-contact-status-app');
};
